import type { ReactNode } from 'react';
import React from 'react';
import HtmlBox from '../../../component_library/components/HtmlBox';
import type { ILoginFormDobData } from '../../../dotcms/dotcms-models/dotcms-login-form-dob';
import type { ITheme } from '../../../component_library/styles/theme';
import Input from '../../../component_library/components/Input';
import type { IPropsWithTestId } from '../../../constants/data-element-tracking-ids';

interface IProps extends IPropsWithTestId {
  employeeId: string | undefined;
  setEmployeeId: (value: string | undefined) => void;
  showError: boolean;
  label: ReactNode;
  data: ILoginFormDobData;
  theme: ITheme;
}

export const LoginDobFormEmployeeId: React.FC<IProps> = ({
  dataElementId,
  employeeId,
  setEmployeeId,
  showError,
  label,
  data,
  theme,
}) => (
  <Input
    id="login-employee-id"
    dataElementId={dataElementId}
    type="text"
    value={employeeId}
    onChange={setEmployeeId}
    label={label}
    placeholderText={data.employeeIdFieldPlaceholder}
    customError={
      showError ? <HtmlBox html={data.employeeIdFieldError} /> : undefined
    }
    fullWidth
    theme={theme}
  />
);
